// extracted by mini-css-extract-plugin
export default {"container":"Products_container__gOtz6","products":"Products_products__xaC2Q","menu":"Products_menu__HJZ59","list":"Products_list__nmY3a","product":"Products_product__GZYBp"};